import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { FinancingModalTrigger } from "../apps/financing/FinancingModalTrigger";

type IProps = Immutable<templates.FinancingFormTemplate>;

export const Template = (props: IProps): React.JSX.Element => {
    return (
        <FinancingModalTrigger
            modalType="full-app"
            className={props.link_class}
            title={props.link_title}
            applicationSource={props.application_source}
        >
            {props.link_text}
        </FinancingModalTrigger>
    );
};
